export default {
    state: {
    },
    mutations: {
        UPD_PARALLAX: (state) => {
            let  parallax = document.getElementById('first-screen__bg');
            window.addEventListener('scroll', function () {
                let offset = window.pageYOffset;
                parallax.style.bottom = offset * 0.1 + 'px';
            });
        }
    },
    actions: {
        PARALLAX_EF ({commit}) {
            commit('UPD_PARALLAX')
        }
    },
    getters: {
    },
}
